export interface NamedSelectOption {
   name: string | null;
}

export function filterNamedOption<T extends NamedSelectOption>(types: T[], searchText: string | null | undefined): T[] {
   if (types.length === 0) {
      return [];
   }
   const term = searchText && searchText.trim();
   if (term) {
      const upper = term.toUpperCase();
      return types.filter((item) => {
         return item.name ? item.name.toUpperCase().includes(upper) : false;
      });
   } else {
      return types || [];
   }
}

export interface DisplayNamedSelectOption {
   displayName: string | null;
}

export function filterDisplayNamedOption<T extends DisplayNamedSelectOption>(
   types: T[],
   searchText: string | null | undefined
): T[] {
   if (types.length === 0) {
      return [];
   }
   const term = searchText && searchText.trim();
   if (term) {
      const upper = term.toUpperCase();
      return types.filter((item) => {
         return item.displayName ? item.displayName.toUpperCase().includes(upper) : false;
      });
   } else {
      return types || [];
   }
}
